import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Input } from "~/atoms/input";
import { Button } from "~/atoms/button";
import { getSpSiteByUrl } from "~/api/v2/requests";
import { toast } from "react-toastify";

interface Props {
  onSiteFound: (siteId: string) => void;
}

export const SharePointSiteUrlInput = ({ onSiteFound }: Props) => {
  const { t } = useTranslation();
  const [manualUrl, setManualUrl] = useState<string>("");
  const [isValidating, setIsValidating] = useState(false);

  const handleValidateUrl = async () => {
    if (!manualUrl) return;

    setIsValidating(true);
    try {
      const site = await getSpSiteByUrl(manualUrl);
      onSiteFound(site.id);
      toast.success(
        `${t("sharepoint.steps.selectDestination.siteFound")}: ${site.displayName}`,
      );
    } catch (error) {
      console.error("Error validating site URL:", error);
      toast.error(t("sharepoint.steps.selectDestination.urlInvalid"));
    } finally {
      setIsValidating(false);
    }
  };

  return (
    <div className="space-y-4">
      <p className="text-muted-foreground text-sm">
        {t("sharepoint.steps.selectDestination.urlHint")}
      </p>
      <div className="flex gap-2">
        <Input
          type="url"
          placeholder={t("sharepoint.steps.selectDestination.urlPlaceholder")}
          value={manualUrl}
          onChange={(e) => setManualUrl(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              void handleValidateUrl();
            }
          }}
        />
        <Button
          onClick={handleValidateUrl}
          disabled={!manualUrl || isValidating}
        >
          {isValidating
            ? t("commons.buttons.validating")
            : t("commons.buttons.validate")}
        </Button>
      </div>
    </div>
  );
};
